// eslint-disable-next-line
// @ts-nocheck
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Tab from '@mui/material/Tab';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListHead, BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useGetAllServiceProviderDetailMutation } from '../../store/api/serviceProviderApi';
import { getServiceProviderTotalRecords } from '../../store/state/serviceProviderSlice';
import Iconify from '../../components/Iconify';
import { useGetRolesMutation } from '../../store/api/roleApi';
import { getRole } from '../../store/state/roleSlice';

const TABLE_HEAD = [
  { id: 'rolename', label: 'User Role', alignRight: false },
  { id: 'permission ', label: 'Permission ', alignRight: false },
  { id: 'edit ', label: 'Edit ', alignRight: false },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function RoleManagement() {
  const [getAllServiceProviderDetail, getAllResponse] = useGetAllServiceProviderDetailMutation();
  const [parkingSpaces, setParkingSpaces] = useState([]);
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('asc');
  const [filterName, setFilterName] = useState('');
  const [getRoles, getRoleResponse] = useGetRolesMutation();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [roleData, setRoleData] = useState([]);
  const [offset, setOffset] = useState(5);
  const [columName, setColumName] = useState('id');
  const serviceProviderTotalRecords = useAppSelector(getServiceProviderTotalRecords);
  const authData = JSON.parse(localStorage.getItem('login') || '{}');
  const filteredUsers = applySortFilter(parkingSpaces, getComparator(order, orderBy), filterName);
  const isUserNotFound = filteredUsers.length === 0;

  useEffect(() => {
    getRoles({
      token: token,
      payload: {
        merchantId: authData.merchantId,
      },
    });
  }, []);

  useEffect(() => {
    if (getRoleResponse.isSuccess) {
      dispatch(getRole(getRoleResponse.data));
      setRoleData(getRoleResponse.data);
    }
  }, [getRoleResponse.isSuccess]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = parkingSpaces.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllServiceProviderDetail({
      token: token.token,
      payload: {
        page: newPage,
        offset: offset,
        orderBy: orderBy,
        columName: columName,
        currentStatus: 'Pending',
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllServiceProviderDetail({
      token: token.token,
      payload: {
        page: 0,
        offset: parseInt(event.target.value, 10),
        orderBy: orderBy,
        columName: columName,
        currentStatus: 'Pending',
      },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    getAllServiceProviderDetail({
      token: token.token,
      payload: {
        page: page,
        offset: offset,
        orderBy: orderBy,
        columName: columName,
        name: event.target.value,
        currentStatus: 'Pending',
      },
    });
  };

  return (
    <Page title="Vendor's Status">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            User Role Management
          </Typography>
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                navigate('/dashboard/add-role', { state: { editMode: false } });
              }}
              startIcon={<Iconify icon="eva:plus-fill" />}
              size="large"
            >
              Add
            </Button>
          </Box>
        </Stack>
        <Card>
          <BookingListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={parkingSpaces.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {roleData &&
                    roleData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                      const { id, name, rolename, currentStatus } = row;
                      const isItemSelected = selected.indexOf(rolename) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">{row.name}</TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Button
                                onClick={() => {
                                  navigate('/dashboard/add-vendor', {
                                    state: {
                                      editMode: true,
                                      isApproved: true,
                                      id: row.id,
                                    },
                                  });
                                }}
                              >
                                <Typography variant="subtitle2" noWrap pl={2}>
                                  {name}
                                </Typography>
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" alignItems="center">
                              <Button
                                onClick={() => {
                                  navigate('/dashboard/add-role', {
                                    state: {
                                      id: id,
                                      merchantId: merchantId,
                                      commission: commission,
                                      tierType: tierType,
                                      userId: userId,
                                      editMode: true,
                                    },
                                  });
                                }}
                              >
                                <Iconify icon={'eva:edit-outline'} sx={{ fontSize: '20px', color: blue[700] }} />
                              </Button>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={serviceProviderTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
